import { createSlice } from "@reduxjs/toolkit";
const initial = {
    message: "",
    type: null,
};
export const notificationMessageSlice = createSlice({
    name: "notificationMessage",
    initialState: {
        value: initial,
    },
    reducers: {
        setNotificationMessage: (state, action) => {
            state.value = action.payload;
        },
    },
});
export const { setNotificationMessage } = notificationMessageSlice.actions;
export default notificationMessageSlice.reducer;
